import React from 'react';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  RadioGroup,
  Radio,
  Box,
  Flex,
  useColorModeValue,
  Text,
} from '@chakra-ui/react';

const CRadio = ({
  label,
  options = [],
  value,
  onChange,
  required = false,
  isInvalid,
  errorMessage = '',
  disabled
}) => {
  const textColor = useColorModeValue('navy.700', 'white');
  const brandStars = useColorModeValue('red.500', 'red.400');

  return (
    <FormControl isInvalid={isInvalid} mb="24px">
      <FormLabel display="flex" fontSize="l" fontWeight="900" color={textColor} mb="20px" ms="4px">
        {label} {required && <Text color={brandStars}>*</Text>}
      </FormLabel>
      <RadioGroup value={value} onChange={(val) => onChange(val)} isDisabled={disabled} ms="4px">
        <Flex gap="4" w="30%">
          {options.map((option) => (
            <Radio key={option.value} value={option.value} colorScheme="brand" w="100%">
              {option.label}
            </Radio>
          ))}
        </Flex>
      </RadioGroup>
      {isInvalid && errorMessage && (
        <FormErrorMessage>{errorMessage}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export default CRadio;